import {
  applySpec,
  descend,
  map,
  pathOr,
  pipe,
  propOr,
  slice,
  sort,
  values,
} from 'ramda'

import BroadcastSingle from '../../../../../schemas/broadcast/single'
import File from '../../../../../schemas/file'
import eventsSort from '../../../../../utils/events-sort'

const broadcastHomeParser = BroadcastSingle

export const broadcastRegistrationParser = applySpec({
  documents: pipe(propOr([], 'documents'), values, map(File)),
  recording: applySpec({
    id: pathOr('', ['recordingId']),
    otp: pathOr('', ['videoInfo', 'otp']),
    playbackInfo: pathOr('', ['videoInfo', 'playbackInfo']),
  }),
  recordingPurchaseOpen: pathOr(false, ['canSellRecording']),
  recordingRegistration: applySpec({
    billId: pathOr('', ['recordingRegistrations', '0', 'billId']),
    id: pathOr('', ['recordingRegistrations', '0', 'id']),
    status: pathOr('UNREGISTERED', ['recordingRegistrations', '0', 'status']),
  }),
  registration: applySpec({
    billId: pathOr('', ['registrations', '0', 'billId']),
    id: pathOr('', ['registrations', '0', 'id']),
    status: pathOr('UNREGISTERED', ['registrations', '0', 'status']),
  }),
  registrationOpen: pathOr(false, ['canRegister']),
})

export const broadcastQuestionsParser = pipe(
  propOr({}, 'questions'),
  values,
  map(
    applySpec({
      answer: propOr('', 'answer'),
      createdAt: propOr('', 'createdAt'),
      id: propOr('', 'id'),
      question: propOr('', 'question'),
      user: applySpec({
        name: pathOr('', ['user', 'name']),
        picture: pathOr('', ['user', 'profilePicture', 'location']),
      }),
    }),
  ),
  sort(descend(propOr(0, 'createdAt'))),
)

export const broadcastRecommendationsParser = pipe(eventsSort, slice(0, 6))

export default broadcastHomeParser
